export const DEFAULT_INPUT_UNIT_VALUE = 'WEEKS';
export const MIN_DATE_VALUE = 2;
export const MAX_BUSINESS_DAYS_INCREASED = 300;
export const MAX_CALENDAR_DAYS_INCREASED = 400;
export const MAX_WEEKS_INCREASED = 60;
export const OFFLINE_DAYS = ['SATURDAY', 'SUNDAY'];
const defaults = {
  rollingDateValue: MIN_DATE_VALUE,
  rollingDateUnit: 'WEEKS',
  offlineDays: []
};
export function createRollingDateRange(props) {
  var _props$rollingDateVal, _props$rollingDateUni, _props$offlineDays;
  return {
    rollingDateValue: (_props$rollingDateVal = props === null || props === void 0 ? void 0 : props.rollingDateValue) !== null && _props$rollingDateVal !== void 0 ? _props$rollingDateVal : defaults.rollingDateValue,
    rollingDateUnit: (_props$rollingDateUni = props === null || props === void 0 ? void 0 : props.rollingDateUnit) !== null && _props$rollingDateUni !== void 0 ? _props$rollingDateUni : defaults.rollingDateUnit,
    offlineDays: (_props$offlineDays = props === null || props === void 0 ? void 0 : props.offlineDays) !== null && _props$offlineDays !== void 0 ? _props$offlineDays : defaults.offlineDays
  };
}
export function getRollingDateMaxValue(rdr) {
  if (rdr.offlineDays.length > 0) {
    return MAX_BUSINESS_DAYS_INCREASED;
  } else if (rdr.rollingDateUnit === 'DAYS') {
    return MAX_CALENDAR_DAYS_INCREASED;
  }
  return MAX_WEEKS_INCREASED;
}
export function buildRollingDateRangeInputsValue(rdr) {
  return Object.assign({}, rdr, {
    rollingDateUnit: rdr.offlineDays.length >= 1 ? 'BUSINESS_DAYS' : rdr.rollingDateUnit
  });
}
export function hasValidRollingDateValue(rdr) {
  return rdr.rollingDateValue <= getRollingDateMaxValue(rdr);
}
export function validateRollingDateValue(rdr) {
  return createRollingDateRange({
    rollingDateUnit: rdr.rollingDateUnit,
    offlineDays: rdr.offlineDays,
    rollingDateValue: Math.min(rdr.rollingDateValue, getRollingDateMaxValue(rdr))
  });
}
export function rollingDateRangeFromInputsValue(rollingDateRange) {
  const {
    rollingDateUnit,
    rollingDateValue
  } = rollingDateRange;
  return createRollingDateRange({
    rollingDateUnit: rollingDateUnit === 'BUSINESS_DAYS' ? 'DAYS' : rollingDateUnit,
    rollingDateValue,
    offlineDays: rollingDateUnit === 'BUSINESS_DAYS' ? OFFLINE_DAYS : []
  });
}
export function getEmptyRollingDateRange() {
  return createRollingDateRange({
    rollingDateValue: 0,
    rollingDateUnit: 'WEEKS',
    offlineDays: []
  });
}